import React from 'react';
import { FadeIn } from './FadeIn';
import { Check, X } from 'lucide-react';
const withoutGuide = ['Buscar información durante horas', 'Cometer errores costosos', 'No saber qué vender', 'Avanzar por prueba y error', 'Sentirse confundido'];
const withSystem = ['Ruta paso a paso', 'Contenido organizado', 'Recursos listos para usar', 'Menos errores', 'Más claridad desde el primer día'];
export function ComparacionSistema() {
  return <section className="bg-brand-beige/60 px-5 py-20 sm:px-6 md:py-28" data-id="element-117" data-mp="2l2ad9nlkyss3">
      <div className="mx-auto max-w-5xl" data-id="element-118" data-mp="2g6v438yipl20">
        <FadeIn data-id="element-119" data-mp="2uu7tx9vcycy7">
          <div className="mx-auto mb-12 max-w-3xl text-center" data-id="element-120" data-mp="2uupzix3wu3is">
            <p className="mb-3 text-xs font-bold uppercase tracking-[0.2em] text-brand-gold" data-id="element-121" data-mp="2uw124tlmd58b">
              Dos formas de empezar
            </p>
            <h2 className="font-serif text-3xl font-bold leading-tight tracking-tight text-brand-green sm:text-4xl md:text-5xl" data-id="element-122" data-mp="22d3ww789ed9g">
              La diferencia entre empezar solo o hacerlo con un sistema probado
            </h2>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-2 md:gap-6" data-id="element-123" data-mp="2nsld602qphyg">
          <FadeIn data-id="element-124" data-mp="2ru6ovi3jfq72">
            <article className="h-full rounded-3xl border border-brand-text/10 bg-white p-6 sm:p-8" data-id="element-125" data-mp="2rtn4luqf0ppv">
              <h3 className="text-lg font-bold text-brand-text/70" data-id="element-126" data-mp="2wp2iunsc4nmt">
                Empezar sin una guía
              </h3>
              <ul className="mt-6 space-y-4" data-id="element-127" data-mp="24w22358dljz9">
                {withoutGuide.map(item => <li key={item} className="flex items-start gap-3" data-id="element-128" data-mp="28wvnnrycimoz">
                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand-text/8" data-id="element-129" data-mp="28z87ybrkt957">
                      <X className="h-3.5 w-3.5 text-brand-text/45" strokeWidth={3} data-id="element-130" data-mp="2iv1sahbje6xj" />
                    </span>
                    <span className="text-base leading-snug text-brand-text/60" data-id="element-131" data-mp="3pdro8z0fbf4d">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </article>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-132" data-mp="2zo193xh45plv">
            <article className="h-full rounded-3xl border border-brand-gold/40 bg-brand-green p-6 text-white shadow-[0_24px_55px_-32px_rgba(31,61,43,0.8)] sm:p-8" data-id="element-133" data-mp="2zmq5bxno4hur">
              <h3 className="text-lg font-bold text-brand-gold" data-id="element-134" data-mp="39l5ye669a16w">
                Amazon Master System
              </h3>
              <ul className="mt-6 space-y-4" data-id="element-135" data-mp="2lwmt7zii64j1">
                {withSystem.map(item => <li key={item} className="flex items-start gap-3" data-id="element-136" data-mp="2gxtfq737udiv">
                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand-gold/20" data-id="element-137" data-mp="2vm6ax1uhbscb">
                      <Check className="h-3.5 w-3.5 text-brand-gold" strokeWidth={3} data-id="element-138" data-mp="2qtwm5p53oybm" />
                    </span>
                    <span className="text-base font-medium leading-snug text-white/90" data-id="element-139" data-mp="1y727x9yvmv6l">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </article>
          </FadeIn>
        </div>
      </div>
    </section>;
}